<template>
  <div class="wraper-scenario-detail">
    <div class="detail">
      <div class="featured-image" :style="{ backgroundImage: 'url(' + encodeUrlForCss(data.featured_image) + ')' }">
        <img :src="data.bot_character_image_url" class="bot-character" />
      </div>
      <div class="description">
        <div class="title-content">Scenario Details</div>
        <div class="desc-content">{{ data.description }}</div>
      </div>
    </div>
    <div class="line-split"></div>
    <div class="objective">
      <div :style="{ display: 'flex', gap: '8px' }">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23" fill="none">
          <path
            d="M2 15.3462H18.4103M2 21.5H18.4103M5.07691 5.60256L8.15383 8.67949L15.3333 1.5"
            stroke="black"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="title-content">{{ scenarioTasksText }}</div>
      </div>

      <ul class="reset-style">
        <li class="goal desc-content" v-for="(objective, idx) in data.objectives" :key="idx">
          {{ idx + 1 + ". " + objective }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { COMPANY } from "@/constants/organizationType";
export default {
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    orgType: {
      type: String,
      default: "",
    },
  },
  methods: {
    encodeUrlForCss(url) {
      return url.replace(/["'(),]/g, function(match) {
        return "%" + match.charCodeAt(0).toString(16);
      });
    },
  },
  computed: {
    scenarioTasksText() {
      return this.orgType === COMPANY ? this.$t("ai_tutor.ent.scenario_tasks") : this.$t("ai_tutor.ent.scenario_goals")
    }
  }
};
</script>

<style scoped lang="scss">
.wraper-scenario-detail {
  display: flex;
  width: 100%;
  align-items: flex-start;
  width: calc(100vw - 460px);
  margin-left: -50px;
  overflow: hidden;

  .featured-image {
    position: relative;
    width: 198px;
    height: 148px;
    background-size: cover;
    background-position: center;
    border-radius: 8px;
    .bot-character {
      position: absolute;
      max-width: 35%;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .title-content {
    font-size: 20px;
    line-height: 32px;
    font-weight: bold;
    color: #000;
    margin-bottom: 8px;
  }

  .desc-content {
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    color: #373646;
    text-wrap: wrap;
  }

  .detail {
    // width: calc(60% - 1px);
    width: 50%;
    padding-right: 40px;
    display: flex;
    gap: 16px;

    .description {
      flex: 1;
    }
  }
  .objective {
    width: 40%;
    padding-left: 40px;
    text-wrap: wrap;
  }
  .line-split {
    background-color: #dddddd;
    width: 1px;
    height: 170px;
  }
  .reset-style {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
</style>
